module.exports = __webpack_public_path__ + "2d3075a1230e4f9627a9ef9b439e12ec.svg";